import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-f', 'IconLetterF', [
  ['path', { d: 'M17 4h-10v16', key: 'svg-0' }],
  ['path', { d: 'M7 12l8 0', key: 'svg-1' }],
]);
